import { colors } from '../../colors';
var blogList = {
  borderColor: colors.overcast,
  bgColor: colors.whiteish,
  breadcrumbColor: colors.graphite,
  subHeadingColor: colors.graphite,
  headingColor: colors.graphite,
  paraColor: colors.graphite,
  filterTextColor: colors.graphite
};
export default blogList;